import { createFileRoute } from '@tanstack/react-router';

import {
  ShipmentsPage,
  validateShipmentsSearch,
} from '../../features/shipments';

export const Route = createFileRoute('/_app/shipments')({
  staticData: { crumbs: ['Отгрузки в работе'] },
  // Фильтры, сортировка и страница живут в адресной строке - валидируем их здесь.
  validateSearch: validateShipmentsSearch,
  component: ShipmentsPage,
});
